import * as PIXI from "pixi.js";
import gsap from "gsap";
import { Scene } from "onearm";
import { Signal } from "typed-signals";

export class BasePopupScene extends Scene {
    onClosed = new Signal();

    _overlay = null;
    _panel = null;

    create() {
        super.create();

        // Overlay
        this._overlay = new PIXI.Graphics();
        this._overlay.rect(0, 0, 1920, 1080);
        this._overlay.fill({ color: 0x000000, alpha: 0.6 });
        this._overlay.eventMode = "static";
        this.addChild(this._overlay);

        // Panel container
        this._panel = new PIXI.Container();
        this.addChild(this._panel);

        // Fade in
        this.alpha = 0;
        gsap.to(this, { alpha: 1, duration: 0.3, ease: "sine.out" });
    }

    close() {
        gsap.to(this, { alpha: 0, duration: 0.3, ease: "sine.in", onComplete: () => {
            this.onClosed.emit();
        }});
    }

    _addCloseButton(x, y) {
        const resources = this.services.get("resources");
        const closeTex = resources.get("close_btn/default");
        if (!closeTex) return;

        const btn = new PIXI.Sprite(closeTex);
        btn.anchor.set(0.5);
        btn.position.set(x, y);
        btn.eventMode = "static";
        btn.cursor = "pointer";
        btn.on("pointertap", () => this.close());
        this._panel.addChild(btn);
    }
}
